import { Toaster as Sonner, toast } from "sonner";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import { cn } from "@/lib/utils";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Sonner
      className="toaster group"
      position="top-right"
      toastOptions={{
        duration: 4000,
        classNames: {
          toast: cn(
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground",
            "group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            "group-[.toaster]:rounded-xl",
            !prefersReducedMotion && "animate-slide-in-right"
          ),
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toast]:border-primary/50",
          error: "group-[.toast]:border-destructive/50",
        },
      }}
      {...props}
    />
  );
};

// Enhanced toast with icon animations
const showSuccessToast = (message: string, description?: string) => {
  toast.success(message, {
    description,
    icon: (
      <svg
        className="h-5 w-5 text-primary animate-check-draw"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 13l4 4L19 7" />
      </svg>
    ),
  });
};

const showErrorToast = (message: string, description?: string) => {
  toast.error(message, {
    description,
    icon: (
      <svg
        className="h-5 w-5 text-destructive animate-shake"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    ),
  });
};

export { Toaster, toast, showSuccessToast, showErrorToast };
